import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addError } from 'actions';
import { createConversation, getConversationsByReference, submitMessage, getConversation } from 'actions/conversation';
import Modal from 'containers/Modals/Modal';
import ConversationMessages from 'containers/Conversation/Display/ConversationMessages';
import MessageForm from 'containers/Conversation/Form/MessageForm';
import { Spinner } from 'UI';
import { translate } from '@haldor/ui';
var Message = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function Message(props) {
    var _this;
    _classCallCheck(this, Message);
    _this = _callSuper(this, Message, [props]);
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      // Get conversations
      var studentId = _this.props.activeStudent.id;
      if (_this.props.assignment != null) {
        var assignment = _this.props.assignment;
        _this.props.getConversationsByReference(assignment.id, 'ASSIGNMENT', studentId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
      if (_this.props.plan != null) {
        var plan = _this.props.plan;
        _this.props.getConversationsByReference(plan.id, 'PLAN', studentId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
      if (_this.props.meetingInstance != null) {
        var meetingInstance = _this.props.meetingInstance;
        _this.props.getConversationsByReference(meetingInstance.id, 'MEETING_INSTANCE').then(function () {
          _this.setState({
            loading: false
          });
        });
      }
      _this.setState({
        user: _this.props.profile
      });
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.activeUser == null) {
        return false;
      }
      if (nextProps.activeUser != _this.props.activeUser) {
        var creator = {
          id: _this.getCreatorId()
        };
        var conversation = _this.getConversationForUser(creator);
        if (conversation != null && conversation.id != 0) {
          _this.setState({
            loading: true
          });
          _this.props.getConversation(conversation.id).then(function () {
            _this.setState({
              loading: false
            });
          });
        }
      }
    });
    /* Helper methods */
    _defineProperty(_this, "getCreatorId", function () {
      var creator = null;
      if (_this.props.assignment != null) {
        if (_this.props.assignment.id == parseInt(_this.props.assignment.id, 10)) {
          creator = _this.props.assignment.creator;
        } else {
          creator = _this.props.assignment.createdBy.user.id;
        }
      }
      if (_this.props.plan != null) {
        creator = _this.props.plan.creator;
      }
      if (_this.props.meetingInstance != null) {
        creator = _this.props.meetingInstance.creator;
      }
      return creator;
    });
    _defineProperty(_this, "buildReference", function (studentId) {
      var references = [];
      var reference = {};
      if (_this.props.assignment != null) {
        reference.referenceId = _this.props.assignment.id;
        reference.referenceType = 'ASSIGNMENT';
      }
      if (_this.props.plan != null) {
        reference.referenceId = _this.props.plan.id;
        reference.referenceType = 'PLAN';
      }
      if (_this.props.meetingInstance != null) {
        reference.referenceId = _this.props.meetingInstance.id;
        reference.referenceType = 'MEETING_INSTANCE';
      }
      references.push(reference);
      if (studentId != null && studentId != "") {
        references.push({
          referenceType: 'STUDENT',
          referenceId: studentId
        });
      }
      return references;
    });
    _defineProperty(_this, "buildMemberships", function (student) {
      var memberships = [];
      if (_this.props.meetingInstance != null) {
        memberships.push({
          membershipID: _this.props.activeUser.id,
          membershipType: 'USER',
          permission: 'W'
        });
      } else {
        var owner = _this.getCreatorId();
        if (owner != null) {
          memberships.push({
            membershipID: owner,
            membershipType: 'USER',
            permission: 'W'
          });
        }
      }
      return memberships;
    });
    _defineProperty(_this, "getConversationForUser", function (user) {
      var conversations = _this.props.conversations;
      if (conversations != null) {
        var found = conversations.find(function (conversation) {
          var membership = conversation.memberships.find(function (member) {
            return member.membershipType == 'USER' && member.membershipID == user.id;
          });
          return membership != null;
        });
        return found;
      }
      return null;
    });
    _defineProperty(_this, "getMembership", function (conversation, userid) {
      var membership = conversation.memberships.find(function (member) {
        return member.membershipType == 'USER' && member.membershipID == userid;
      });
      if (membership != null) {
        return membership;
      }
      return null;
    });
    /* Events */
    _defineProperty(_this, "onModalClose", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    });
    _defineProperty(_this, "onCreate", function (values, user) {
      return new Promise(function (resolve) {
        var studentId = "";
        if (_this.props.meetingInstance != null) {
          studentId = _this.props.meetingInstance.studentId;
        } else {
          studentId = _this.props.activeUser.id;
        }
        values.creator = _this.props.profile.id;
        delete values.conversationID;
        var conversation = {
          messages: [values],
          memberships: _this.buildMemberships(user),
          relationships: _this.buildReference(studentId),
          title: '',
          status: 'ACTIVE'
        };
        _this.props.createConversation(conversation, studentId).then(function () {
          //this.props.getConversation(this.props.new);
          _this.componentDidMount();
          _this.props.getConversation(_this.props["new"]);
          _this.props.addError(_this.props.translate('Message sent'), 'info');
          resolve(1);
        });
      });
    });
    _defineProperty(_this, "submitMessage", function (values) {
      return new Promise(function (resolve) {
        var user = _this.state.user;
        values.creator = user.id;
        _this.props.submitMessage(values).then(function () {
          _this.setState({});
          resolve(1);
        });
      });
    });
    _defineProperty(_this, "toggleConversation", function (open, conversation, user) {
      var conversations = _this.props.conversations;
      if (open) {
        _this.setState({
          open: user.id
        });
      } else {
        _this.setState({
          open: ''
        });
      }
      if (open && conversation.id != 0) _this.props.getConversation(conversation.id);
    });
    /* Render methods */
    _defineProperty(_this, "renderStudentConversation", function () {
      var creator = {
        id: _this.getCreatorId()
      };
      var conversation = _this.getConversationForUser(creator);
      var created = true;
      if (conversation == null) {
        created = false;
        conversation = {
          id: 0
        };
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper",
        style: {
          boxShadow: 'none',
          borderRadius: 0,
          height: '70vh'
        }
      }, created ? /*#__PURE__*/React.createElement(ConversationMessages, {
        conversation: _this.props.active
      }) : /*#__PURE__*/React.createElement("div", {
        className: "conversation-begin"
      }, _this.props.translate('Begin conversation')), created ? /*#__PURE__*/React.createElement(MessageForm, {
        conversation: conversation,
        onSubmit: _this.submitMessage,
        button: _this.props.translate('Send')
      }) : /*#__PURE__*/React.createElement(MessageForm, {
        conversation: null,
        onSubmit: function onSubmit(values) {
          return _this.onCreate(values, _this.props.profile);
        },
        button: _this.props.translate('Send')
      }));
    });
    _defineProperty(_this, "renderContent", function () {
      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      return _this.renderStudentConversation();
    });
    _this.state = {
      loading: true,
      open: ''
    };
    return _this;
  }
  _inherits(Message, _Component);
  return _createClass(Message, [{
    key: "render",
    value: function render() {
      if (this.props.activeUser == null) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        onClose: this.onModalClose,
        isOpen: true,
        title: this.props.translate('Conversation with teacher')
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-assignment-message"
      }, this.renderContent()));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    conversations: state.Conversation.referenceConversations,
    active: state.Conversation.conversation,
    profile: state.profile.profile,
    "new": state.Conversation["new"],
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getConversationsByReference: getConversationsByReference,
  createConversation: createConversation,
  addError: addError,
  submitMessage: submitMessage,
  getConversation: getConversation
})(Message);